"use client";

import React from "react";
import { useEffect, useState } from "react";
import "./CompletedProjects.css";
import Link from "next/link";

export default function CompletedProjects({ completedPropertylist }) {
  const [isMobilescreen, setMobileScreen] = useState(false);
  useEffect(() => {
    if (window.innerWidth <= 767) {
      setMobileScreen(true);
    }
  }, []);

  // page_title: "Completed Residential & Commercial Projects | Swati Procon",
  // 		page_description: "Explore Swati Procon's successfully completed projects, including luxury apartments, office spaces, and retail showrooms across Ahmedabad.",
  // 		page_keywords: "Completed real estate projects, Swati Procon developments, luxury apartments Ahmedabad, commercial spaces, successful projects",
  //   const seoMetaData = {
  //     page_title: "Completed Residential & Commercial Projects | Swati Procon",
  //     page_description:
  //       "Explore Swati Procon's successfully completed projects, including luxury apartments, office spaces, and retail showrooms across Ahmedabad.",
  //     page_keywords:
  //       "Completed real estate projects, Swati Procon developments, luxury apartments Ahmedabad, commercial spaces, successful projects",
  //     slug: "/completed-projects",
  //     image: "/images/sswati-procon.png",
  //   };

  if (completedPropertylist.length > 0) {
    return (
      <>
        {/* {seoMetaData && <Seo metaData={seoMetaData} />} */}
        <div className="reecosys-main-wrapper" id="reecosys-main-wrapper">
          <div id="reecosys-list-wrapper" className="relative ">
            <section className="reecosys-section" id="reecosys-list-section-2">
              <div className="main-container-fluid">
                <div className="inner-flex">
                  <div
                    className="flex-row flex-col-mob j-c-sb alc "
                    data-aos="fade-in"
                    data-aos-delay="600"
                    data-aos-duration="800"
                  >
                    <div
                      className="section-title "
                      data-aos="fade-in"
                      data-aos-delay="600"
                      data-aos-duration="600"
                    >
                      <h2>Completed Projects</h2>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="reecosys-section section-padding pb0 overflow"
              id="reecosys-list-section-3"
            >
              <div className="main-container-fluid">
                <div className="completedProjectList">
                  {completedPropertylist.map((data, index) => (
                    <div key={index} className="compeletedProjectItem">
                      <Link href={`/${data.slug}`}>
                        <div
                          className={`flex-row alc ${
                            isMobilescreen ? "w100" : ""
                          } `}
                        >
                          <div
                            className={`completedProjectImg ${
                              isMobilescreen ? "w100" : ""
                            }`}
                          >
                            {!isMobilescreen && (
                              <img
                                src={`${data.banners_data.images[0].image_web_full}&w=200&h=160&q=100`}
                                alt=""
                              />
                            )}
                            {isMobilescreen && (
                              <img
                                src={`${data.banners_data.images[0].image_web_full}&h=300&q=100`}
                                style={{ height: "300px" }}
                                className="w100"
                                alt=""
                              />
                            )}
                          </div>
                          <div className="section-title">
                            <h2>{data.project_title}</h2>
                          </div>
                        </div>
                        <div className="inner-flex inner-flex-small completedLocaitonFlex">
                          <div className="flex-row alc section-content">
                            <span>
                              <img
                                src="/images/icon/building.svg"
                                alt={data.project_title}
                                className="completedProjectIcon"
                              />
                            </span>
                            <p>{data.size_price}</p>
                          </div>
                          <div className="flex-row alc section-content">
                            <span>
                              <img
                                src="/images/icon/location.svg"
                                alt={data.project_title}
                                className="completedProjectIcon"
                              />
                            </span>
                            <p>{data.location}</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
        </div>

        <style></style>
      </>
    );
  } else {
    return <h1>Please Wait</h1>;
  }
}
